import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AppConstants } from '../_constants/constants';

@Injectable()
export class VerifiedSellerGuard implements CanActivate {

    constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';

        // For SSR: Allow access (server can't check localStorage)
        // Client-side auth check will happen after hydration
        if (!isBrowser) {
            return true;
        }

        const currentUserJson = localStorage.getItem(AppConstants.CURRENT_USER_KEY);
        const currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;

        // Check if user is logged in, is a seller, and has VERIFIED status
        if (currentUser &&
            currentUser.role &&
            currentUser.role.toLowerCase() === 'seller' &&
            currentUser.seller &&
            currentUser.seller.status === 'VERIFIED') {
            // Seller is verified - allow access to sell page
            return true;
        }

        // User is not a verified seller - redirect to dashboard with warning
        this.router.navigate(['/user/dashboard'], {
            replaceUrl: true,
            queryParams: { warning: 'seller_pending_approval' }
        });
        return false;
    }
}
